import { CompetitionDefaults } from "../events/entity";
import { getAgeTypeFromString, getCompetitionClassTypeFromString, getCompetitionNaming, getCompetitionTypeFromString, getCompetitorTypeFromString, getDisciplineTypeFromString, getSeriesTypeFromString } from "../view/entity";
export function getCompetitionNamingResults(c) {
    var comp = Object.create(CompetitionDefaults);
    if (c != null) {
        comp.dances = c.dances;
        comp.seriesId = getSeriesTypeFromString(c.series);
        comp.ageId = getAgeTypeFromString(c.age);
        comp.disciplineId = getDisciplineTypeFromString(c.discipline);
        comp.typeId = getCompetitionTypeFromString(c.grade);
        comp.competitorId = getCompetitorTypeFromString(c.competitors);
        comp.fromClassId = getCompetitionClassTypeFromString(c.class);
        comp.toClassId = getCompetitionClassTypeFromString(c.toClass);
        return getCompetitionNaming(comp);
    }
    return '';
}
